/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';

/* Styles */
/* Services */

/**
 * Renders SadhguruSignatureLoveGrace Component
 *
 * @param {object} Card
 * @returns {ReactElement} SadhguruSignatureLoveGrace Component
 */

const SadhguruSignatureLoveGrace = ({ card }) => {
  // console.log('record', card);
  return (
    <Box width={{ base: '100%', md: '288px' }} my="20px">
      <Box
        fontSize="20px"
        mb="18px"
        color="#6D6358"
        fontFamily={'var(--FedraSansStd-book)'}
      >
        {card?.text?.json['love and grace']}
      </Box>
      {card?.text?.json['sadhguru-signature'] && (
        <LazyLoadImageComponent
          src={card?.text?.json['sadhguru-signature']}
          alt="Sadhguru Signature"
          objectFit="cover"
          maxW="178px"
        />
      )}
    </Box>
  );
};

export default SadhguruSignatureLoveGrace;
